import React from "react";
import PageNotFound from "./PageNotFound";
import githubIcon from "../assets/images/github-mark/github-mark-white.png";
import styles from "./ProjectPage.module.css";
import Gallery from "./Gallery";

const validHtmlTags = new Set([
  "a", "abbr", "address", "area", "article", "aside", "audio", "b", "base",
  "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption",
  "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details",
  "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption",
  "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head",
  "header", "hgroup", "html", "i", "img", "input", "ins", "kbd",
  "label", "legend", "li", "link", "main", "map", "mark", "meta", "meter",
  "nav", "noscript", "object", "optgroup", "option", "output", "p",
  "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script",
  "section", "select", "small", "source", "span", "strong", "style", "sub",
  "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea",
  "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "var",
  "video", "wbr",
]); //  "ul", "ol", "hr", "iframe"

const isHtmlTag = (tag) => validHtmlTags.has(tag);


function capitalize(str, split=" ") {
  const strs = str.split(split);
  var ret = ""
  for (var i = 0; i < strs.length; i++) {
    ret += strs[i][0].toUpperCase() + strs[i].slice(1) + " ";
  }
  return ret;
}

function renderList(listType, list, key=null){
  var listItems = [];
  var keyOffset = 0;
  for (var i = 0; i < list.length; i++){
    if (typeof(list[i]) != "object"){
      listItems.push(<li key={i+keyOffset}>{processText(list[i])}</li>);
      continue;
    }
    
    const listTitle = Object.keys(list[i])[0];

    listItems.push(<li key={i}>{processText(listTitle)}</li>);
    listItems.push(renderList(listType, list[i][listTitle], i+1));

    keyOffset++;
  }
  var attr = {className: styles.list};
  if (key != null)
    attr["key"] = key;
  return React.createElement(listType, attr, listItems)
}

function processText(content){
  var ret = []
  /// Find and replace any markdown links with html links
  const linkRegex = /\[(.*?)]\((.*?)\)/;
  var res = linkRegex.exec(content);

  while (res != null){
    var textStart = res.index;
    var textLen = res[0].length;

    var newLink = <a key="2" href={res[2]}>{res[1]}</a>;
    ret.push(<span key="1">{content.slice(0, textStart)}</span>);
    ret.push(newLink);
    ret.push(<span key="3">{content.slice(textStart+textLen)}</span>);
    content = content.slice(0, textStart) + newLink + content.slice(textStart+textLen);

    res = linkRegex.exec(content);
  }
  if (ret.length === 0)
    return content;
  return ret;
}

function renderPage(content) {
  return [...content].map((element, i) => {
    if (Array.isArray(element)){
      return (
        <div key={i} className={styles.section}>
          {renderPage(element)}
        </div>
      
      )
    }

    var elementType = Object.keys(element)[0];
    var content = element[elementType];

    if (!isHtmlTag(elementType)){
      if (elementType === "gallery"){
        console.log(content);
        const imageList = content["items"][0]["images"];
        return <Gallery images={imageList} imagesPerPage={9} key={i} />
      }

      if (elementType === "hr")
        return <hr key={i}/>
      
      if (elementType === "iframe")
        return React.createElement(elementType, {key: i, className:styles.embed, ...content});
      
      if (elementType === "ul" || elementType === "ol"){
        return React.cloneElement(renderList(elementType, content, i),
                                   {key: i, className:styles.list});
      }
      if (elementType === "images"){
        const images = content;
        var imageElements = [];
        for (var j = 0; j < images.length; j++){
          const img = images[j];
          if (!Number.isInteger(img["width"]) || !Number.isInteger(img["height"]))
            continue;
          var aspectRatio = img["width"] / img["height"];
          imageElements.push(
            <span style={{flex: aspectRatio.toString()}} key={j}>
              <img src={img["src"]} alt={img["alt"]} className={styles.preview_image}  />
            </span>
          )
         
        }
        return React.createElement("div", {className: styles.image_container, key: i}, imageElements);
      }
      return null;
    }

    return React.createElement(elementType, {key:i}, processText(content));//renderElement(element, i);
  })
}

export default function ProjectPage(props) {
  const path = window.location.href;

  const projectState = props.projectState;
  if (projectState.status === 404){
    return <PageNotFound/>
  }
  const projectPage = projectState.project;

  if (projectPage == null)
    return null;

  var pageContent;
  try {
    pageContent = JSON.parse(projectPage.pageContent);
  } catch (e) {
    pageContent = []
  }

  const project = projectPage.project;
  if (project == null)
    return null;
  var name = capitalize(path.slice(path.lastIndexOf("/")+1, path.length), "-"), date="", description="", githubLink="";
  var previewImages = []
  if (project != null){
    name = project.name;
    date = project.date;
    description=project.description;
    previewImages = project.previewImages;
    githubLink = project.github;
  }
  console.log(pageContent);
  
  var githubObject = null;
  if (githubLink !== null && githubLink !== "" && githubLink !== "_")
    githubObject = <a href={githubLink}><img className={styles.github_icon} 
    src={githubIcon} alt="Github icon"></img></a>;
  

  return (
    <div className={styles.project_page}>
      <div className={styles.project_head}>
        <h1 className={styles.project_name}>{name}</h1>
        <h3>{date}</h3>
        {githubObject}
        
        
      </div>
      <hr/>
      <div className={styles.section}>
        {renderPage(pageContent)}
      </div>

    </div>
  );
}

